// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"ea29eded","703":"be682320"}[chunkId] + ".chunk.js";
};